import { toast, type ToastPosition, type ToastIcon } from 'react-toastify'

export type ToastType = 'success' | 'error' | 'info' | 'warn' | 'warning'

export interface ToastOptions {
  type: ToastType
  message?: string
  position?: ToastPosition
  duration?: number
  icons?: React.ReactNode
}

export function Toast({ type, message = '', position, duration, icons }: ToastOptions) {
  const p = position || 'top-right'
  const newType = type === 'warning' || type === 'warn' ? 'warn' : type

  return toast[newType](message, {
    position: p,
    autoClose: duration || 3000,
    className: `${type}`,
    icon: icons ? (icons as any as ToastIcon) : undefined,
    toastId: message,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  })
}
